<nz-tabset
  [nzDestroyInactiveTabPane]="true"
  [(nzSelectedIndex)]="selectedTabIndex"
  (nzSelectedIndexChange)="updateUrlWithTabParam()"
>
  <nz-tab nzTitle="Workbench">
    <ng-template nz-tab>
      <div nz-row>
        <div nz-col nzSpan="24">
          <nz-radio-group [(ngModel)]="selectedWorkbenchType" (ngModelChange)="onWorkbenchTypeChange($event)">
            <label for="standard-templates" nz-radio [nzValue]="WorkbenchType.STANDARD_TEMPLATES"
              >Standard Templates</label
            >
            <label for="custom-query" *ngIf="!isMarketingUser" nz-radio [nzValue]="WorkbenchType.CUSTOM_QUERY"
              >Custom Query</label
            >
          </nz-radio-group>
        </div>
      </div>
      <app-standard-templates
        *ngIf="selectedWorkbenchType === WorkbenchType.STANDARD_TEMPLATES"
        [editRecord]="standardEditRecord"
        (editQueryRequested)="moveToCustomQuery($event)"
        (historyTabRequested)="moveToHistoryTab()"
      ></app-standard-templates>
      <app-custom-query
        *ngIf="selectedWorkbenchType === WorkbenchType.CUSTOM_QUERY && !isMarketingUser"
        [queryRecord]="queryRecord"
        (historyTabRequested)="moveToHistoryTab()"
      ></app-custom-query>
    </ng-template>
  </nz-tab>
  <nz-tab nzTitle="Scheduling">
    <ng-template nz-tab>
      <app-scheduling></app-scheduling>
    </ng-template>
  </nz-tab>
  <nz-tab *ngIf="!isMarketingUser" nzTitle="Segment Size Analyzer">
    <ng-template nz-tab>
      <app-segment-size-analyzer
        [editQueryRecord]="segmentEditRecord"
        (historyTabRequested)="moveToHistoryTab()"
      ></app-segment-size-analyzer>
    </ng-template>
  </nz-tab>
  <nz-tab nzTitle="History">
    <ng-template nz-tab>
      <app-history></app-history>
    </ng-template>
  </nz-tab>
</nz-tabset>
